function InterestCalculator() {
    return (
        <div>
            <h2>Interest Calculator</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default InterestCalculator;